<prism-checkbox
	id="sh-device-channel"
	[checked]="params.value?.selected"
	(valueChange)="onCheckboxChange($event.detail)"
>
</prism-checkbox>
